(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define(
      'product-modal',
      class ProductModal extends ModalDialog {
        constructor() {
          super();
        }

        hide() {
          super.hide();
          window.pauseAllMedia();
        }

        show(opener) {
          super.show(opener);
          this.showActiveMedia();
        }

        showActiveMedia() {
          this.querySelectorAll(
            `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
          ).forEach((element) => {
            element.classList.remove('active');
          });
          const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
          activeMedia.classList.add('active');
          activeMedia.scrollIntoView();

          const container = this.querySelector('[role="document"]');
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

          const template = activeMedia.querySelector('template');
          if (!template) return;
          const templateContent = template.content;
          if (!templateContent) return;

          if (activeMedia.nodeName == 'DEFERRED-MEDIA' && templateContent.querySelector('.js-youtube'))
            activeMedia.loadContent();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.isHidden = false;

      // Always sticky — CSS handles first scroll from top with no animation
      this.header.classList.add('shopify-section-header-sticky');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => { this.preventReveal = true; };

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      const observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].boundingClientRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollingDown = scrollTop > this.currentScrollTop;
      const scrollingUp = scrollTop < this.currentScrollTop;
      const nearTop = scrollTop <= this.headerBounds.height;

      if (this.preventReveal) {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        if (!nearTop) this.hide();
      } else if (nearTop) {
        // Approaching/at top — show instantly, never fade through a hide
        this.showInstant();
      } else if (scrollingDown) {
        this.reveal();
      } else if (scrollingUp) {
        this.hide();
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isHidden) return;
      this.isHidden = true;
      this.header.classList.add('shopify-section-header-hidden');
      this.closeMenuDisclosure();
      const cartDrawerOpen = document.querySelector('.cart-drawer-open');
      const menuDrawerOpen = document.querySelector('menu-drawer.menu-drawer-open');
      if (!cartDrawerOpen && !menuDrawerOpen && typeof knocking !== 'undefined') {
        knocking.hideBlur();
      }
    }

    /** Used by cart-notification.js */
    reveal() {
      if (!this.isHidden) return;
      this.isHidden = false;
      this.header.classList.remove('shopify-section-header-hidden');
    }

    showInstant() {
      if (!this.isHidden) return;
      this.isHidden = false;
      this.header.style.transition = 'none';
      this.header.classList.remove('shopify-section-header-hidden');
      this.header.offsetHeight;
      this.header.style.transition = '';
    }

    closeMenuDisclosure() {
      const menuDrawer = document.querySelector('menu-drawer');
      if (menuDrawer && menuDrawer.classList.contains('menu-drawer-open')) {
        menuDrawer.dispatchEvent(new CustomEvent('close-menu'));
      }
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...store.fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-cbs-deals-box"]) return;
  try {
    
  // class ProductModal extends ModalDialog {
  // constructor() {
  //     super();
  // }

  // hide() {
  //     super.hide();
  //     window.pauseAllMedia();
  // }

  // show(opener) {
  //     super.show(opener);
  //     this.showActiveMedia();
  // }

  // showActiveMedia() {
  //     this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
  //         element.classList.remove('active');
  //       }
  //     )
  //     const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
  //     activeMedia.classList.add('active');
  //     activeMedia.scrollIntoView();

  //     const container = this.querySelector('[role="document"]');
  //     container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

  //     if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
  //       activeMedia.loadContent();
  // }
  // }

  // customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  if (!customElements.get('product-recommendations')) {
    customElements.define(
      'product-recommendations',
      class ProductRecommendations extends HTMLElement {
        constructor() {
          super();

          const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);

            fetch(this.dataset.url)
              .then((response) => response.text())
              .then((text) => {
                const html = document.createElement('div');
                html.innerHTML = text;
                const recommendations = html.querySelector('product-recommendations');
                if (recommendations && recommendations.innerHTML.trim().length) {
                  this.innerHTML = recommendations.innerHTML;
                }
              })
              .catch((e) => {
                console.error(e);
              });
          };

          new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
